import dayjs from 'dayjs';

export type Time = string | number | Date | dayjs.Dayjs;

/**
 *
 * 格式化为本地展示时间
 *
 * ```ts
 * @param time 时间
 * @param format 格式化方式
 * @return 本地时间展示
 * ```
 */
export const formatLocalTime = (time: Time, format = 'YYYY-MM-DD HH:mm:ss') =>
  `${dayjs.utc(time).local().format(format)}`;

export const formatUTC = (time: Time, format = 'YYYY-MM-DD HH:mm:ss') =>
  `${dayjs.utc(time).format(format)}`;

export const getTime = (time: number) => {
  const totalSeconds = Math.floor(time / 1000);

  const totalMinutes = Math.floor(totalSeconds / 60);

  // 计算小时数
  const hours = Math.floor(totalMinutes / 60);

  // 计算剩余的分钟数
  const minutes = totalMinutes % 60;

  if (hours === 0) return `${minutes}min`;
  return `${hours}H ${minutes}min`;
};
